export enum SystemParameterKey {
  /** 後台系統登入帳號 */
  BACKEND_LOGIN_ACCOUNT = 'BACKENDLOGINACCOUNT',
  /** 商務卡到期月份 */
  BUSINESS_CARD_EXPIRY_MONTH = 'BUSINESSCARDEXPIRYMONTH',
  /** 商務卡收件月份 */
  BUSINESS_CARD_RECEIVE_MONTH = 'BUSINESSCARDRECEIVEMONTH',
  /** 商務卡申請狀態 */
  BUSINESS_CARD_STATUS = 'BUSINESSCARDSTATUS',
  /** 業務往來紀錄狀態 */
  BUSINESSRECORDSTATUS = 'BUSINESSRECORDSTATUS',
  /** 業務往來紀錄類型 */
  BUSINESSRECORDTYPE = 'BUSINESSRECORDTYPE',
  /** 業務往來紀錄類型分類 */
  BUSINESS_RECORD_TYPE_CLASSIFICATION = 'BUSINESSRECORDTYPECLASSIFICATION',
  /** 商機來源 */
  BUSINESS_SOURCE = 'BUSINESSSOURCE',
  /** 官網購票異動動作 */
  BOOKING_SYSTEM_ACTION = 'BOOKINGSYSTEMACTION',
  /** 分類通知 */
  CATEGORY_NOTIFY = 'CATEGORYNOTIFY',
  /** 禮遇手動核銷狀態 */
  COURTESY_WRITEOFF_STATUS = 'COURTESYWRITEOFFSTATUS',
  /** 城市 */
  CITY = 'CITY',
  /** 回饋項目審核項目 */
  COMMON_COMMODITY_REVIEW_ITEM = 'COMMONCOMMODITYREVIEWITEM',
  /** 回饋項目狀態 */
  COMMON_COMMODITY_STATUS = 'COMMONCOMMODITYSTATUS',
  /** 企業員工上限哩程 */
  COMPANY_EMPLOYEE_MAX_MILEAGE = 'COMPANYEMPLOYEEMAXMILEAGE',
  /** 會員審核項目 */
  COMPANY_EMPLOYEE_REVIEW_ITEM = 'COMPANYEMPLOYEEREVIEWITEM',
  /** 合約自動續約年 */
  CONTRACT_AUTO_RENEW_YEAR = 'CONTRACTAUTORENEWYEAR',
  /** 合約延長失效月份 */
  CONTRACT_EXTENSION_EXPIRATION_MONTH = 'CONTRACTEXTENSIONEXPIRATIONMONTH',
  /** 合約審核項目 */
  CONTRACT_REVIEW_ITEM = 'CONTRACTREVIEWITEM',
  /** 合約狀態 */
  CONTRACT_STATUS = 'CONTRACTSTATUS',
  /** 合約類型 */
  CONTRACT_TYPE = 'CONTRACTTYPE',
  /** 企業帳號異動動作 */
  CORPORATE_ACCOUNT_ACTION = 'CORPORATEACCOUNTACTION',
  /** 企業帳號狀態 */
  CORPORATE_ACCOUNT_STATUS = 'CORPORATEACCOUNTSTATUS',
  /** 企業上限哩程 */
  CORPORATE_MAX_MILEAGE = 'CORPORATEMAXMILEAGE',
  /** 客戶狀態 */
  CORPORATE_STATUS = 'CORPORATESTATUS',
  /** 所在地 */
  COUNTRY = 'COUNTRY',
  /** 商品來源 */
  COURTESY_SOURCE = 'COURTESYSOURCE',
  /** 禮遇狀態 */
  COURTESY_STATUS = 'COURTESYSTATUS',
  /** 國家代碼 */
  COUNTRY_CODE = 'COUNTRYCODE',
  /** 幣別 */
  CURRENCY = 'CURRENCY',
  /** 預設檔案路徑 */
  DEFAULT_FILE_PATH = 'DEFAULTFILEPATH',
  /** 預設哩程券哩程數 */
  DEFAULT_MILEAGE = 'DEFAULTMILEAGE',
  /** 預設點數序號 */
  DEFAULT_POINT_GUID = 'DEFAULTPOINTGUID',
  /** 部門 */
  DEPARTMENT = 'DEPARTMENT',
  /** 國內機場 */
  DOMESTIC_AIRPORT = 'DOMESTICAIRPORT',
  /** 發放歷程狀態 */
  DISTRIBUTION_RECORD_STATUS = 'DISTRIBUTIONRECORDSTATUS',
  /** 成效來源 */
  EFFECT_SOURCE = 'EFFECTSOURCE',
  /** 會員尊享 - 類/分類選項  */
  EXCLUSIVE_OFFER_TYPE = 'EXCLUSIVEOFFERTYPE',
  /** 會員尊享 - 狀態 */
  EXCLUSIVE_OFFER_STATUS = 'EXCLUSIVEOFFERSTATUS',
  /** 會員尊享 - 審核 - 執行動作 */
  EXCLUSIVE_OFFER_REVIEW_ITEM = 'EXCLUSIVEOFFERREVIEWITEM',
  /** 會員尊享 - 權重 */
  EXCLUSIVE_OFFER_PRIORITY = 'EXCLUSIVEOFFERPRIORITY',
  /** 獎勵項目申請狀態 */
  REWARDS_APPLICATION_STATUS = 'REWARDSAPPLICATIONSTATUS',
  /** 點數/獎勵項目申請審核項目 */
  REWARDS_APPLICATION_REVIEW_ITEM = 'REWARDSAPPLICATIONREVIEWITEM',
  /** 獎勵項目發放狀態 */
  REWARDS_DISTRIBUTION_STATUS = 'REWARDSDISTRIBUTIONSTATUS',
  /** 點數/獎勵項目發放審核項目 */
  REWARDS_DISTRIBUTION_REVIEW_ITEM = 'REWARDSDISTRIBUTIONREVIEWITEM',
  /** 獎勵項目發放類型 */
  REWARDS_DISTRIBUTION_TYPE = 'REWARDSDISTRIBUTIONTYPE',
  /** 長榮組織部門 */
  FM_DOMAIN = 'FMDOMAIN',
  /** 串接組織人員帳號 */
  FM_SERVICE_ACCOUNT = 'FMSERVICEACCOUNT',
  /** 串接組織人員密碼 */
  FM_SERVICE_LATCHKEY = 'FMSERVICELATCHKEY',
  /** Footer 連結 */
  FOOTER_URL = 'FOOTERURL',
  /** 專人交付地區 */
  HAND_DELIVERY_BY_AREA = 'HANDDELIVERYBYAREA',
  /** 歷史禮遇狀態 */
  HISTORY_COURTESY_STATUS = 'HISTORYCOURTESYSTATUS',
  /** 產業別 */
  INDUSTRY = 'INDUSTRY',
  /** FFP註冊連結 */
  INVITATION = 'INVITATION',
  /** 邀請信有效小時 */
  INVITATION_VALID_HOURS = 'INVITATIONVALIDHOURS',
  /** 識別碼動作 */
  IDENTIFIER_ACTION = 'IDENTIFIERACTION',
  /** 雜項檔動作 */
  MISCELLANEOUS_ACTION = 'MISCELLANEOUSACTION',
  /** 停機啟用 */
  MAINTENANCE_ENABLED = 'MAINTENANCEENABLED',
  /** 停機起始日期 */
  MAINTENANCE_START_DATE = 'MAINTENANCESTARTDATE',
  /** 停機截止日期 */
  MAINTENANCE_END_DATE = 'MAINTENANCEENDDATE',
  /** 停機白名單 */
  MAINTENANCE_WHITE_LIST = 'MAINTENANCEWHITELIST',
  /** 會員身份 */
  IDENTITY = 'IDENTITY',
  /** 加入我們連結 */
  JOIN_US_URL = 'JOINUSURL',
  /** 語系 */
  LANG = 'LANG',
  /** 語系時間格式 */
  LANG_TIME_FORMAT = 'LANGTIMEFORMAT',
  /** 限量額度區間 */
  LIMITED_QUOTA_RANGE = 'LIMITEDQUOTARANGE',
  /** 月份 */
  MONTH = 'MONTH',
  /** 優惠標籤 */
  OFFER_TAG = 'OFFERTAG',
  /** 鄉鎮市 */
  OPTIONAL = 'OPTIONAL',
  /** 成效結算週期 - 達標制 */
  PERFORMANCE_BILLING_CYCLE_STANDARD = 'PERFORMANCEBILLINGCYCLESTANDARD',
  /** 點數到期月份 */
  POINTS_EXPIRY_MONTH = 'POINTSEXPIRYMONTH',
  /** 點數狀態 */
  POINT_STATUS = 'POINTSTATUS',
  /** 方案審核項目 */
  PROGRAM_REVIEW_ITEM = 'PROGRAMREVIEWITEM',
  /** 方案狀態 - 審核作業區 */
  PROGRAM_STATUS_BY_REVIEW = 'PROGRAMSTATUSBYREVIEW',
  /** 方案狀態 */
  PROGRAM_STATUS = 'PROGRAMSTATUS',
  /** 艙等 */
  RBD = 'RBD',
  /** 手動核銷艙等 */
  RBD_BY_WRITE_OFF = 'RBDBYWRITEOFF',
  /** 退改方案 - Global */
  RFD_PROGRAM_BY_GLOBAL = 'RFDPROGRAMBYGLOBAL',
  /** 退改方案 - Local */
  RFD_PROGRAM_BY_LOCAL = 'RFDPROGRAMBYLOCAL',
  /** 通路 */
  ROUTE = 'ROUTE',
  /** 稱謂 */
  SALUTATION = 'SALUTATION',
  /** 寄件方式 */
  SHIPPING_METHOD = 'SHIPPINGMETHOD',
  /** 簽核案件類型 */
  SIGN_OFF_ENTITY_TYPE = 'SIGNOFFENTITYTYPE',
  /** 簽核狀態 */
  SIGN_OFF_STATUS = 'SIGNOFFSTATUS',
  /** 客戶終止合約對應合約狀態 */
  TERMINATED_CONTRACT_STATUS = 'TERMINATEDCONTRACTSTATUS',
  /** 票券使用效期 */
  TICKET_VALIDITY_PERIOD = 'TICKETVALIDITYPERIOD',
  /** 差旅航線 */
  TRAVEL_AIRLINE = 'TRAVELAIRLINE',
  /** 差旅偏好 */
  TRAVEL_PREFERENCE = 'TRAVELPREFERENCE',
  /** 會員尊享 - 時區 */
  TIME_ZONE = 'TIMEZONE',
  /** 方案檻次 */
  PROGRAM_THRESHOLD = 'PROGRAMTHRESHOLD',
  /** 上傳檔案目前空間 */
  UPLOAD_FILE_CURRENT_SPACE = 'UPLOADFILECURRENTSPACE',
  /** 上傳檔案最大空間 */
  UPLOAD_FILE_MAXIMUM_SIZE = 'UPLOADFILEMAXIMUMSIZE',
  /** 是否可以上傳檔案 */
  WHETHER_UPLOAD_FILE = 'WHETHERUPLOADFILE',
  /** 禮遇項目類別 */
  REWARD_CATEGORY = 'REWARDCATEGORY',
  /** 航線 */
  AIRLINE = 'AIRLINE',
  /** 機場禮遇 */
  APPR = 'APPR',
  /** 購票優惠碼 */
  BTDC = 'BTDC',
  /** 商務卡別 */
  SPEC = 'SPEC',
  /** 獎勵地區 */
  ZONE = 'ZONE',
  /** 定額減價 */
  FDIS = 'FDIS',
  /** 酬賓機票 艙等選項(全球不限航點/亞洲區間) */
  FQTRRBD = 'FQTRRBD',
  /** 酬賓機票 艙等選項(台灣-香港/港澳) */
  FQTRRBD_BY_HM = 'FQTRRBDBYHM',
  /** 升等券 艙等選項(全球不限航點/亞洲區間) */
  FQTU = 'FQTU',
  /** 升等券 艙等選項(台灣-香港/港澳) */
  FQTU_BY_HM = 'FQTUBYHM',
  /** 酬賓機票艙等 - 手動核銷 */
  FQTR_RBD_BY_WRITE_OFF = 'FQTRRBDBYWRITEOFF',
  /** 升等券訂位艙等 - 手動核銷 */
  FQTU_RBD_BY_WRITE_OFF = 'FQTURBDBYWRITEOFF',
  /** 升等券實際艙等 - 手動核銷 */
  FQTU_ACTUAL_RBD_BY_WRITE_OFF = 'FQTUACTUALRBDBYWRITEOFF',
  /** 行李區域 */
  PDBG = 'PDBG',
  /** 折扣減價 */
  PDIS = 'PDIS',
  /** FAQ 檔案 */
  FAQ_FILE_LIST = 'FAQFILELIST',
  /** 企業官網購票艙等 */
  CIBS_CABIN_CLASS = 'CIBSCABINCLASS',
  /** 企業官網購票票價種類 */
  CIBS_DISPLAY_TYPE = 'CIBSDISPLAYTYPE',
  /** 指派獎勵 (中文) */
  ASSIGN_REWARDS_ZH = 'ASSIGN_REWARDS_ZH',
  /** 指派獎勵 (英文) */
  ASSIGN_REWARDS_EN = 'ASSIGN_REWARDS_EN',
  /** 指派獎勵 (韓文) */
  ASSIGN_REWARDS_KR = 'ASSIGN_REWARDS_KR',
  /** 指派獎勵 (日文) */
  ASSIGN_REWARDS_JP = 'ASSIGN_REWARDS_JP',
  /** 指派獎勵 (越南文) */
  ASSIGN_REWARDS_VN = 'ASSIGN_REWARDS_VN',
  /** 指派獎勵 (泰文) */
  ASSIGN_REWARDS_TH = 'ASSIGN_REWARDS_TH',
  /** 指派獎勵 (高棉文/柬埔寨) */
  ASSIGN_REWARDS_KH = 'ASSIGN_REWARDS_KH',
  /** 指派獎勵連結 (中文) */
  ASSIGN_REWARDS_ZH_URL = 'ASSIGN_REWARDS_ZH_URL',
  /** 指派獎勵連結 (英文) */
  ASSIGN_REWARDS_EN_URL = 'ASSIGN_REWARDS_EN_URL',
  /** 指派獎勵連結 (韓文) */
  ASSIGN_REWARDS_KR_URL = 'ASSIGN_REWARDS_KR_URL',
  /** 指派獎勵連結 (日文) */
  ASSIGN_REWARDS_JP_URL = 'ASSIGN_REWARDS_JP_URL',
  /** 指派獎勵連結 (越南文) */
  ASSIGN_REWARDS_VN_URL = 'ASSIGN_REWARDS_VN_URL',
  /** 指派獎勵連結 (泰文) */
  ASSIGN_REWARDS_TH_URL = 'ASSIGN_REWARDS_TH_URL',
  /** 指派獎勵連結 (高棉文/柬埔寨) */
  ASSIGN_REWARDS_KH_URL = 'ASSIGN_REWARDS_KH_URL',
  /** 綁定教學影片連結 (中文) */
  BINDING_VIDEO_ZH_URL = 'BINDING_VIDEO_ZH_URL',
  /** 綁定教學影片連結 (英文) */
  BINDING_VIDEO_EN_URL = 'BINDING_VIDEO_EN_URL',
  /** 綁定教學影片連結 (韓文) */
  BINDING_VIDEO_KR_URL = 'BINDING_VIDEO_KR_URL',
  /** 綁定教學影片連結 (日文) */
  BINDING_VIDEO_JP_URL = 'BINDING_VIDEO_JP_URL',
  /** 綁定教學影片連結 (越南文) */
  BINDING_VIDEO_VN_URL = 'BINDING_VIDEO_VN_URL',
  /** 綁定教學影片連結 (奧地利德文) */
  BINDING_VIDEO_AT_URL = 'BINDING_VIDEO_AT_URL',
  /** 綁定教學影片連結 (德文) */
  BINDING_VIDEO_DE_URL = 'BINDING_VIDEO_DE_URL',
  /** 綁定教學影片連結 (義大利文) */
  BINDING_VIDEO_IT_URL = 'BINDING_VIDEO_IT_URL',
  /** 差旅人禮遇教學影片連結 (中文) */
  TRAVELER_REWARD_VIDEO_ZH_URL = 'TRAVELER_REWARD_VIDEO_ZH_URL',
  /** 差旅人禮遇教學影片連結 (英文) */
  TRAVELER_REWARD_VIDEO_EN_URL = 'TRAVELER_REWARD_VIDEO_EN_URL',
  /** 差旅人禮遇教學影片連結 (韓文) */
  TRAVELER_REWARD_VIDEO_KR_URL = 'TRAVELER_REWARD_VIDEO_KR_URL',
  /** 差旅人禮遇教學影片連結 (日文) */
  TRAVELER_REWARD_VIDEO_JP_URL = 'TRAVELER_REWARD_VIDEO_JP_URL',
  /** 差旅人禮遇教學影片連結 (越南文) */
  TRAVELER_REWARD_VIDEO_VN_URL = 'TRAVELER_REWARD_VIDEO_VN_URL',
  /** 差旅人禮遇教學影片連結 (泰文) */
  TRAVELER_REWARD_VIDEO_TH_URL = 'TRAVELER_REWARD_VIDEO_TH_URL',
  /** 差旅人禮遇教學影片連結 (高棉文/柬埔寨) */
  TRAVELER_REWARD_VIDEO_KH_URL = 'TRAVELER_REWARD_VIDEO_KH_URL'
}
